import React from 'react';

const Star = ({ rating }) => {
  return (
    <>
      {/* estrellas doradas */}
      {[...Array(rating)].map((x, i) => (
        <i key={i} className="fas fa-star" style={{ color: '#FDAA29' }}>
          {' '}
        </i>
      ))}

      {/* estrellas grises */}
      {[...Array(5 - rating)].map((x, i) => (
        <i key={i} className="fas fa-star" style={{ color: '#B3B3B3' }}>
          {' '}
        </i>
      ))}
    </>
  );
};

export default Star;
